


















































import {
  computed,
  defineComponent,
  ref,
  useStore,
} from '@nuxtjs/composition-api'
import NavigationSectionSubpageSelect from '@/components/Navigation/NavigationSectionSubpageSelect.vue'
import NavigationLink from '@/components/Navigation/NavigaitionLink.vue'
import { navigationSectionProps } from '@/mixins/navigationSectionProps'
import NavigationSectionSubpageStepback from '@/components/Navigation/NavigationSectionSubpageStepback.vue'

export default defineComponent({
  name: 'NavigationSectionSubpage',
  components: {
    NavigationSectionSubpageStepback,
    NavigationSectionSubpageSelect,
    NavigationLink,
  },
  mixins: [navigationSectionProps],
  setup(props) {
    const store = useStore()
    const activeSectionId = ref(null)
    const gridItems = computed(() => props.children.slice(0, -1))
    const lastItem = computed(() =>
      props.children.length > 0
        ? props.children[props.children.length - 1]
        : null
    )
    const activeSection = computed(() =>
      props.children.find((child) => child.id === activeSectionId.value)
    )
    const setActiveSection = (id) => {
      store.commit('navigation/SET_IS_SUBPAGE_OPEN', !!id)
      activeSectionId.value = id
      try {
        const modalBody = document.querySelector(
          '.modal-body'
        ) as HTMLDivElement
        modalBody.scrollTop = 0
      } catch (e) {
        Logger.error('Cannot scroll to 0 or cannot select element', e)
      }
    }
    return {
      gridItems,
      lastItem,
      activeSection,
      activeSectionId,
      setActiveSection,
    }
  },
})
